import {
  Box,
  Flex,
  Popover,
  type PopoverProps,
  Text,
} from '@mantine/core'
import { useRouter } from 'next/router'

import { useTranslation } from '@flecto/translations'
import { type CoreProduct } from '@flecto/types'

import { AvatarItem } from '..'
import { BadgeItemInsurance } from '../BadgeItemInsurance/BadgeItemInsurance'
import classes from './styles.module.css'

export type PopoverBookingProductBundleItems = PopoverProps & {
  product: CoreProduct
  withBadgeInsurance?: boolean
}

export function PopoverBookingProductBundleItems({
  product,
  withBadgeInsurance = true,
  children,
  ...props
}: PopoverBookingProductBundleItems) {
  const router = useRouter()
  const { t } = useTranslation('shared', { keyPrefix: 'shared' })

  if (!product?.bundle) {
    return children
  }

  return (
    <Popover position='bottom' width={330} withinPortal {...props}>
      <Popover.Target>
        <Box data-testid='popover-target'>{children}</Box>
      </Popover.Target>
      <Popover.Dropdown data-testid='popover-dropdown'>
        {product.bundle_attributes?.bundle_items?.map((bi) => (
          <Box
            key={bi.id}
            className={classes.item}
            onClick={() => router.push('/items')}
            data-testid='popover-item'
          >
            <AvatarItem item={bi.item} className={classes.avatar} />
            <Flex className={classes.title} align='center' gap='xs'>
              <Text fw={500}>{bi.item.title}</Text>
              {withBadgeInsurance && <BadgeItemInsurance item={bi.item} />}
            </Flex>
            <Text fw={500} className={classes.quantity}>
              x{bi.quantity}
            </Text>
            <Text size='sm' c='dimmed' className={classes.id}>
              ID: {bi.item.internal_id}
            </Text>
            <Text size='sm' c='dimmed' className={classes.availability}>
              {bi.item.quantity_available} {t('available')}
            </Text>
          </Box>
        ))}
      </Popover.Dropdown>
    </Popover>
  )
}
